/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Cat_Unsportsmanlike_ConductInputs */



/**
* | output |
* | --- |
* | "Unsportsmanlike Conduct" |
*
* @param {Sanction_Cat_Unsportsmanlike_ConductInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_cat_unsportsmanlike_conduct = /** @type {((inputs?: Sanction_Cat_Unsportsmanlike_ConductInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Cat_Unsportsmanlike_ConductInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conduite Antisportive")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conducta Antideportiva")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conduta Antidesportiva")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condotta Antisportiva")
	return /** @type {LocalizedString} */ ("Unsportsmanlike Conduct")
});